import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { Input, Table, Button, Select, Dropdown, Menu, DatePicker } from "antd";
import { SearchOutlined, PlusOutlined, PrinterOutlined, DownOutlined } from "@ant-design/icons";
import "antd/dist/antd.css";
import dayjs from "dayjs";
import Cookies from 'js-cookie';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { itemRender, onShowSizeChange } from "../../../../paginationfunction";
import { useAuth } from "../../../../context/AuthContext";
import moment from 'moment';
import locale from 'antd/es/date-picker/locale/bn_BD';
// import "../../../antdstyle.css";
import "../../components/caseStyle.css";
import { govtlogo } from '../../../../Entryfile/imagepath';
import {
    getRunningDistrictCaseReportApi,
    getDistrictsApi,
    getCourtTypesApi,
    getFinalResultApi,
    getHearingDatesByCaseEntryApi,
    createHearingDateApi,
    deleteHearingDateApi,
    updateCaseEntryCommentApi,
    getResponsibleOfficersApi,
    createResponsibleOfficersApi,
    getDocumentsByCaseEntryApi,
    addDocumentApi,
    deleteDocumentApi,
} from '../../../../api/master.api';
import { uploadGeneralCaseFileApi } from '../../../../api/uploadFile.api';

const { Option } = Select;
const { RangePicker } = DatePicker;
const dateFormat = "YYYY-MM-DD";
dayjs.extend(customParseFormat);

const apiOrigin = (process.env.REACT_APP_API_URL || 'https://scms.infotechitsolutionsbd.com/').replace(/\/$/, '');
const resolveDocHref = (fileUrl) => {
    if (!fileUrl) return '#';
    const s = String(fileUrl);
    if (s.startsWith('http://') || s.startsWith('https://')) return s;
    return `${apiOrigin}${s.startsWith('/') ? s : `/${s}`}`;
};

const RunningCaseReport = () => {
    const logInStatus = parseInt(Cookies.get("Role"));
    const toBnDigits = (value) => {
        const en = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
        const bn = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

        // প্রথমে value-কে string-এ রূপান্তর করা
        let strValue = String(value);

        // যদি সংখ্যাটি ১ থেকে ৯ এর মধ্যে হয়, তবে সামনে একটি '0' যোগ করবে (01, 02...09)
        // ১০ বা তার বেশি হলে কিছু করবে না
        const num = Number(value);
        if (!isNaN(num) && num >= 1 && num <= 9) {
            strValue = strValue.padStart(2, '0');
        }

        return strValue.replace(/[0-9]/g, d => bn[en.indexOf(d)]);
    };
    
    const { user, logout } = useAuth();
    const [data, setData] = useState([]);
    const [allData, setAllData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filters, setFilters] = useState({
        district: "",
        courtType: "",
        lawOfficer: "",
        caseNo: "",
        caseType: ""
    });
    const [dateRange, setDateRange] = useState(null);
    const [dateRange1, setDateRange1] = useState(null);

    const [isModalVisible, setIsModalVisible] = useState(false);
    const [finalResultData, setFinalResultData] = useState({});
    const [modalLoading, setModalLoading] = useState(false);
   const getSafeDateValue = (dateString) => {
        if (!dateString) return null;
        return dayjs(dateString, 'YYYY-MM-DD').isValid() ? dayjs(dateString, 'YYYY-MM-DD') : null;
    };

    // Hearing Date Modal States
    const [isHearingModalVisible, setIsHearingModalVisible] = useState(false);
    const [selectedCaseId, setSelectedCaseId] = useState(null);
    const [hearingFormData, setHearingFormData] = useState({
        hearing_date: '',
        next_hearing_date: '',
        hearing_notes: ''
    });
    const [hearingDates, setHearingDates] = useState([]);
    const [hearingModalLoading, setHearingModalLoading] = useState(false);
    // Comment Modal States
    const [isCommentModalVisible, setIsCommentModalVisible] = useState(false);
    const [commentCaseId, setCommentCaseId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const [commentModalLoading, setCommentModalLoading] = useState(false);
    // Responsible Officers Modal States
    const [isOfficerModalVisible, setIsOfficerModalVisible] = useState(false);
    const [officerModalLoading, setOfficerModalLoading] = useState(false);
    const [officerCaseId, setOfficerCaseId] = useState(null);
    const [officers, setOfficers] = useState([
        { name: '', profession: '', phone: '' }
    ]);

    // Sample data based on the image
    useEffect(() => {

        const getUsers = async () => {
            try {
                const { data: reportRes } = await getRunningDistrictCaseReportApi();
                const getSignData = Array.isArray(reportRes.data) ? reportRes.data : [];
                setAllData(getSignData);
                setData(getSignData);
            } catch (err) {
                console.error(err);
            } finally {
                setLoading(false);
            }
        };
        getUsers();
    }, [loading]);


    const [districts, setDistricts] = useState([]);
    useEffect(() => {
        const getDistricts = async () => {
            try {
                const { data: body } = await getDistrictsApi();
                const list = Array.isArray(body.data) ? body.data : [];
                const options = list.map((item) => ({
                    value: item.district_id,
                    label: `${item.district_name} (${item.division_name})`,
                }));
                setDistricts(options);
            } catch (err) {
                console.error(err);
            }
        };
        getDistricts();
    }, []);

    const [courtTypes, setCourtTypes] = useState([]);
    useEffect(() => {
        const getCourtTypes = async () => {
            try {
                const { data: body } = await getCourtTypesApi();
                const list = Array.isArray(body.data) ? body.data : [];
                const options = list.map((item) => ({
                    value: item.court_type_id,
                    label: `${item.court_type_name}`,
                }));
                setCourtTypes(options);
            } catch (e) {
                console.error(e);
            }
        };
        getCourtTypes();
    }, []);


    // console.log(data, "data")
    // useEffect(() => {
    //     setData(sampleData);
    // }, []);

    const handleFilterChange = (field, value) => {
        setFilters(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleSearch = () => {
        setLoading(true);

        const trimmedCaseNo = (filters.caseNo || "").trim().toLowerCase();
        const [startDate, endDate] = dateRange || [];
        const startTs = startDate ? dayjs(startDate).startOf('day').valueOf() : null;
        const endTs = endDate ? dayjs(endDate).endOf('day').valueOf() : null;

        const [startDate1, endDate1] = dateRange1 || [];
        const startTs1 = startDate1 ? dayjs(startDate1).startOf('day').valueOf() : null;
        const endTs1 = endDate1 ? dayjs(endDate1).endOf('day').valueOf() : null;


        const filtered = (allData || []).filter((item) => {
            if (filters.district && String(item.district_id) !== String(filters.district)) {
                return false;
            }
            if (filters.courtType && String(item.court_type_id) !== String(filters.courtType)) {
                return false;
            }
            if (trimmedCaseNo) {
                const caseNumber = String(item.case_number || "").toLowerCase();
                if (!caseNumber.includes(trimmedCaseNo)) {
                    return false;
                }
            }
            if (filters.caseType && String(item.case_type_id || "") !== String(filters.caseType)) {
                return false;
            }
            if (startTs && endTs) {
                const itemDate = item.next_hearing_date
                    ? dayjs(item.next_hearing_date, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "DD-MM-YYYY"], true)
                    : null;
                if (!itemDate || !itemDate.isValid()) {
                    return false;
                }
                const itemTs = itemDate.startOf('day').valueOf();
                if (itemTs < startTs || itemTs > endTs) {
                    return false;
                }
            }
            if (startTs1 && endTs1) {
                const itemDate1 = item.filing_date
                    ? dayjs(item.filing_date, ["YYYY-MM-DD", "DD/MM/YYYY", "YYYY/MM/DD", "DD-MM-YYYY"], true)
                    : null;
                if (!itemDate1 || !itemDate1.isValid()) {
                    return false;
                }
                const itemTs1 = itemDate1.startOf('day').valueOf();
                if (itemTs1 < startTs1 || itemTs1 > endTs1) {
                    return false;
                }
            }


            return true;
        });

        setData(filtered);
        setLoading(false);
    };

    const fetchFinalResultData = async (caseEntryId) => {
        setModalLoading(true);
        try {
            const { data: body } = await getFinalResultApi(caseEntryId);
           const list =body.data ? body.data : [];
            setFinalResultData(list || {});
            setIsModalVisible(true);
        } catch (error) {
            console.error("Error fetching final result data:", error);
        } finally {
            setModalLoading(false);
        }
    };

    // Hearing Date Modal Functions
    const handleHearingDateClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setHearingFormData({
            hearing_date: '',
            next_hearing_date: '',
            hearing_notes: ''
        });
        setIsHearingModalVisible(true);
        setHearingModalLoading(true);

        // Fetch existing hearing dates
        try {
            const { data: body } = await getHearingDatesByCaseEntryApi(record.case_entry_id);
            setHearingDates(Array.isArray(body.data) ? body.data : []);
        } catch (err) {
            console.error('Error fetching hearing dates:', err);
            setHearingDates([]);
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleHearingFormSubmit = async () => {
        if (!hearingFormData.hearing_date) {
            alert('সর্বশেষ শুনানির তারিখ ফিল্ড পূরণ করুন');
            return;
        }

        setHearingModalLoading(true);
        try {
            await createHearingDateApi({
                case_entry_id: selectedCaseId,
                hearing_date: hearingFormData.hearing_date,
                next_hearing_date: hearingFormData.next_hearing_date,
                hearing_notes: hearingFormData.hearing_notes
            });
            alert('শুনানি তারিখ সফলভাবে যোগ করা হয়েছে');
            const { data: body } = await getHearingDatesByCaseEntryApi(selectedCaseId);
            setHearingDates(Array.isArray(body.data) ? body.data : []);
            setHearingFormData({
                hearing_date: '',
                next_hearing_date: '',
                hearing_notes: ''
            });
        } catch (err) {
            console.error('Error adding hearing date:', err);
            alert('শুনানি তারিখ যোগ করতে ব্যর্থ');
        } finally {
            setHearingModalLoading(false);
        }
    };

    const handleHearingModalClose = () => {
        setIsHearingModalVisible(false);
        setSelectedCaseId(null);
        setHearingFormData({
            hearing_date: '',
            next_hearing_date: '',
            hearing_notes: ''
        });
        setHearingDates([]);
    };


    // Comment Modal Functions
    const handleCommentClick = async (record) => {
        setCommentCaseId(record.case_entry_id);
        setCommentText(record.case_comment);
        setIsCommentModalVisible(true);
        setCommentModalLoading(false);
    };

    const handleCommentSubmit = async () => {
        if (!commentText.trim()) {
            alert('মন্তব্য ফিল্ড পূরণ করুন');
            return;
        }

        setCommentModalLoading(true);
        try {
            await updateCaseEntryCommentApi({
                case_entry_id: commentCaseId,
                case_comment: commentText.trim()
            });
            alert('মন্তব্য সফলভাবে আপডেট করা হয়েছে');
            handleCommentModalClose();
            setLoading(true);
        } catch (err) {
            console.error('Error updating comment:', err);
            alert('মন্তব্য আপডেট করতে ব্যর্থ');
        } finally {
            setCommentModalLoading(false);
        }
    };

    const handleCommentModalClose = () => {
        setIsCommentModalVisible(false);
        setCommentCaseId(null);
        setCommentText('');
    };

    // Responsible Officers Modal Functions
    const handleResponsibleOfficerClick = async (record) => {
        setOfficerCaseId(record.case_entry_id);
        setIsOfficerModalVisible(true);
        setOfficerModalLoading(true);
        try {
            const { data: body } = await getResponsibleOfficersApi(record.case_entry_id);
            const items = Array.isArray(body.data) ? body.data : [];
            const mapped = items.map(item => ({
                name: item.name || '',
                profession: item.profession || '',
                phone: item.phone || item.number || ''
            }));
            setOfficers(mapped.length ? mapped : [{ name: '', profession: '', phone: '' }]);
        } catch (err) {
            console.error('Error fetching responsible officers:', err);
            setOfficers([{ name: '', profession: '', phone: '' }]);
        } finally {
            setOfficerModalLoading(false);
        }
    };

    const addOfficerRow = () => {
        setOfficers(prev => ([...prev, { name: '', profession: '', phone: '' }]));
    };

    const removeOfficerRow = (index) => {
        setOfficers(prev => prev.filter((_, i) => i !== index));
    };

    const updateOfficerField = (index, field, value) => {
        setOfficers(prev => prev.map((row, i) => i === index ? { ...row, [field]: value } : row));
    };

    const handleSaveResponsibleOfficers = async () => {
        // Basic validation: at least one row with a name or phone
        const cleaned = officers
            .map(o => ({ name: o.name.trim(), profession: o.profession.trim(), phone: o.phone.trim() }))
            .filter(o => o.name || o.profession || o.phone);
        if (!cleaned.length) {
            alert('কমপক্ষে একটি সারিতে তথ্য দিন');
            return;
        }
        console.log(cleaned, officerCaseId)
        console.log("cleaned")
        setOfficerModalLoading(true);
        try {
            await createResponsibleOfficersApi({
                case_entry_id: officerCaseId,
                officers: cleaned
            });
            alert('দায়িত্বপ্রাপ্ত কর্মকর্তাদের তথ্য সংরক্ষণ করা হয়েছে');
            setIsOfficerModalVisible(false);
            setOfficerCaseId(null);
        } catch (err) {
            console.error('Error saving responsible officers:', err);
            alert('তথ্য সংরক্ষণ ব্যর্থ হয়েছে');
        } finally {
            setOfficerModalLoading(false);
        }
    };


    const handleFinalResultClick = (record) => {
        // console.log("Clicking final result for case:", record.case_entry_id);
        fetchFinalResultData(record.case_entry_id);
    };

    // Unified Select props to match CaseGeneral searchable select design
    const commonSelectProps = {
        showSearch: true,
        allowClear: true,
        style: { width: '100%', height: 36 },
        placeholder: '--- নির্বাচন করুন ---',
        filterOption: (input, option) =>
            option?.children?.toLowerCase?.().indexOf(input.toLowerCase()) >= 0
    };




    const [isDocumentModalVisible, setIsDocumentModalVisible] = useState(false);
    const [documentModalLoading, setDocumentModalLoading] = useState(false);

    const [documents, setDocuments] = useState([]); // Existing docs
    const [docFormData, setDocFormData] = useState({
        document_name: "",
        file: null
    });


    const handleDocumentEntryClick = async (record) => {
        setSelectedCaseId(record.case_entry_id);
        setIsDocumentModalVisible(true);
        setDocumentModalLoading(true);

        try {
            const { data: body } = await getDocumentsByCaseEntryApi(record.case_entry_id);
            setDocuments(Array.isArray(body.data) ? body.data : []);
        } catch (err) {
            console.error("Document fetch error:", err);
            setDocuments([]);
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDocumentSubmit = async () => {
        if (!docFormData.document_name || !docFormData.file) {
            alert("ডকুমেন্ট নাম ও ফাইল দুটোই দিতে হবে");
            return;
        }

        try {
            setDocumentModalLoading(true);
            const uploadRes = await uploadGeneralCaseFileApi(docFormData.file);
            const fileUrl = uploadRes.data?.data?.fileUrl;
            if (!fileUrl) throw new Error('Upload failed');
            const saveRes = await addDocumentApi({
                case_entry_id: selectedCaseId,
                document_name: docFormData.document_name,
                file_url: fileUrl
            });
            const newRow = saveRes.data?.data;
            if (newRow) setDocuments((prev) => [...prev, newRow]);
            setDocFormData({ document_name: "", file: null });
        } catch (err) {
            console.error(err);
            alert("ত্রুটি হয়েছে");
        } finally {
            setDocumentModalLoading(false);
        }
    };

    const handleDeleteDocument = async (docId) => {
        // if (!confirm("আপনি কি ডিলিট করতে চান?")) return;

        await deleteDocumentApi(docId);

        setDocuments(prev => prev.filter(doc => doc.file_id !== docId));
    };

    const handleDocumentModalClose = () => {
        setIsDocumentModalVisible(false);
        setDocFormData({
            document_name: "",
            file: null
        });
    };




    const getActionMenu = (record) => (
        <Menu>


            <Menu.Item key="view"> <Link to={`/report/single-case/view/${record.case_entry_id}`} style={{ textDecoration: 'none' }}> বিস্তারিত তথ্য</Link> </Menu.Item>

            {user.role==="admin" &&

            <Menu.Item key="update">  <Link to={`/district-court-case-update/${record.case_entry_id}`} style={{ textDecoration: 'none' }}> সংশোধন     </Link></Menu.Item>

             } 
            {user.role==="admin" &&
            <>
                <Link to={`/final-result/${record.case_entry_id}`} style={{ textDecoration: 'none' }}>
                    <Menu.Item key="edit">চূড়ান্ত রায় </Menu.Item>
                </Link>
                <Menu.Item key="hearing" onClick={() => handleHearingDateClick(record)}>শুনানি তারিখ </Menu.Item>
            </>
          }
            {user.role==="admin" &&
            <Menu.Item key="edit" onClick={() => handleFinalResultClick(record)}>চূড়ান্ত রায় বিস্তারিত</Menu.Item>
         }
            {user.role==="admin" &&
            <Menu.Item key="comment" onClick={() => handleCommentClick(record)}>মন্তব্য</Menu.Item>
            }
            {user.role==="admin" &&
            <Menu.Item key="responsibleOfficer" onClick={() => handleResponsibleOfficerClick(record)}>দায়িত্বপ্রাপ্ত কর্মকর্তা</Menu.Item>
            }
            {user.role==="admin" &&
            <Menu.Item key="document" onClick={() => handleDocumentEntryClick(record)}>ডকুমেন্ট এন্ট্রি </Menu.Item>
         }

        </Menu>
    );

    const columns = [
        {
            title: " ক্রম",
            key: "serial",
            className: "case_column_bg",
            width: 80,
            align: "center",
            render: (text, record, index) => index + 1,
        },
        {
            title: "মামলা নং",
            dataIndex: "case_number",
            className: "case_column_bg",
            key: "case_number",
            width: 120,
            align: "center",
            onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
        },
        // {
        //     title: "মামলার শ্রেণী/কেস-টাইপ",
        //     dataIndex: "case_type_name",
        //     key: "case_type_name",
        //     width: 200,
        //     align: "center"
        // },
        {
            title: "জেলার নাম ",
            dataIndex: "district_name",
            className: "case_column_bg",
            key: "district_name",
            width: 200,
            align: "center"
        },
        {
            title: "সংশ্লিষ্ট আদালতের নাম",
            dataIndex: "court_type_name",
            className: "case_column_bg",
            key: "court_type_name",
            width: 200,
            align: "left",
            onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
            render: (_, record) => (
                <p>
                    {record.court_type_name}
                </p>
            )
        },
        {
            title: "বাদী ",
            dataIndex: "plaintiffs",
            className: "case_column_bg",
            key: "plaintiffs",
            width: 180,
            align: "left",
            onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
        },
        {
            title: "বিবাদী",
            dataIndex: "defendants",
            className: "case_column_bg",
            key: "defendants",
            width: 180,
            align: "left",
            onCell: () => ({
                style: { whiteSpace: "normal", wordBreak: "break-word" }
            }),
            render: (text) => {
                if (!text) return null;
                return text.split("$").map((item, index) => (
                    <div key={index}>{`${index + 1}. ${item.trim()}`}</div>
                ));
            },

        },

        {
            title: "মামলার বিষয়বস্তু",
            dataIndex: "case_description",
            className: "case_column_bg",
            key: "case_description",
            align: "left",
            onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } })
        },

        {
            title: "সর্বশেষ অবস্থা",
            dataIndex: "hearing_date",
            className: "case_column_bg",
            key: "hearing_date",
            width: 150,
            align: "center",
            onCell: () => ({ style: { whiteSpace: 'normal', wordBreak: 'break-word' } }),
            render: (_, record) => (
                <p>

                    {record.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${record.hearing_date}` : ""}
                    <br />
                    {record.next_hearing_date ? 'ও' : ""}
                    <br />
                    {record.next_hearing_date ? `পরবর্তী শুনানীর তারিখ: ${record.next_hearing_date}` : ""}
                </p>
            )
        },
        {
            title: "অবস্থা",
            dataIndex: "case_status",
            className: "case_column_bg",
            key: "case_status",
            width: 150,
            align: "center",
            render: (_, record) => (
                <p>
                    {record.case_status === 1 ? "মামলা চলমান" : "নিষ্পত্তিকৃত মামলা"}
                    <br />
                    {record.case_comment ? ` ও ${record.case_comment}` : ""}
                </p>
            )
        },
        {
            title: "অ্যাকশন",
            key: "action",
            className: "case_column_bg",
            width: 120,
            align: "center",
            render: (_, record) => (
                <Dropdown overlay={getActionMenu(record)} trigger={['click']}>
                    <Button type="primary" size="small" style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}>
                        অ্যাকশন <DownOutlined />
                    </Button>
                </Dropdown>
            )
        }
    ];


    const generatePrintContent = () => {
        return `
    <!DOCTYPE html>
    <html>
    <head>
        <meta charset="utf-8">
       
        <style>
            body {
                margin: 0;
                padding: 20px;
                font-size: 12px;
                line-height: 1.4;
                font-family: 'Nikosh', 'NikoshBAN', 'SolaimanLipi', Arial, Helvetica, sans-serif;
            }
            .header {
                text-align: center;
                margin-bottom: 30px;
            }
            .logo {
                width: 150px;
                height: 80px;
                margin: 0 auto 10px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
            }
            .header-text {
                margin: 5px 0;
                font-weight: bold;
            }
            .main-title {
                font-size: 14px;
                font-weight: bold;
                margin: 10px 0;
                text-align: left;
            }
            .address {
                font-size: 10px;
                margin: 5px 0;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 20px;
                font-size: 10px;
            }
            th, td {
                border: 1px solid #000;
                padding: 5px;
                text-align: center;
                vertical-align: top;
                font-size: 12px
            }
            th {
                background-color: #f5f5f5;
                font-weight: bold;
               font-size: 12px
            }
            .serial {
                width: 40px;
            }
            .case-no {
                width: 120px;
            }
            .court-info {
                width: 150px;
            }
            .parties {
                width: 120px;
            }
            .subject {
                width: 100px;
            }
            .status {
                width: 80px;
            }
            .left-align {
                text-align: left;
            }
            @media print {
                body { print-color-adjust: exact; }
                .no-print { display: none; }
            }
        </style>
    </head>
    <body>
        <div class="header">
            <div class="logo">
                <img src=${govtlogo} alt="Bangladesh Logo" style="width: 100%; height: 100%; object-fit: contain;" />
            </div>
            <div class="header-text">সড়ক পরিবহন ও সেতু মন্ত্রণালয়</div>
            <div class="header-text">বাংলাদেশ সেতু কর্তৃপক্ষ</div>
            <div class="header-text">প্রশাসন শাখা</div>
            <div class="address">সেতু ভবন, বনানী, ঢাকা-১২১২</div>
            <div class="address">www.bba.gov.bd</div>
            <div class="main-title">${filters.district ? (data && data.length > 0 && data[0].district_name ? `${data[0].district_name} জেলার` : "") : ""} অন্যান্য অধস্তন আদালতের চলমান মামলার তালিকা:</div>
        </div>
        
        <table>
            <thead>
                <tr>
                    <th class="serial">ক্রম</th>
                    <th class="case-no">মামলার নম্বর</th>
                    <th class="court-info">সংশ্লিষ্ট আদালতের নাম </th>
                    
                    <th class="court-info">সরকারের প্রতিপক্ষের নাম </th>
                    <th class="parties">মামলাভুক্ত সংশ্লিষ্ট মুখ্য দপ্তর / সংস্থার নাম </th>
                    <th class="subject">বিষয় সংক্ষেপে</th>
                    <th class="status">মামলার সর্বশেষ অবস্থা</th>
                     <th class="court-info">সংশ্লিষ্ট আইনজীবীর নাম </th>
                </tr>
                <tr>
                     <th>১</th>
                     <th>২</th>
                    <th>৩</th>
                    <th>৪</th>
                    <th>৫</th>
                    <th>৬</th>
                    <th>৭</th>
                    <th>৮</th>
                </tr>
            </thead>
            <tbody>
                ${data.map((item, index) => `
                    <tr style="page-break-inside: avoid;">
                        <td>${toBnDigits(index + 1)}</td>
                        <td class="left-align">
                           ${toBnDigits(item.case_number)}<br>
                        </td>
                        <td class="left-align"> ${item.court_type_name}
                          
                        </td>
                        
                        <td class="left-align">
                            ${item.plaintiffs}
                        </td>
                        <td class="left-align">
                            ${item.defendants ? item.defendants.split("$")
                .map((d, i) => `${toBnDigits(i + 1)}. ${d.trim()}<br>`)
                .join('') : ''}
                        </td>
                        <td class="left-align">${item.case_description ? item.case_description : ''}</td>
                        <td class="left-align">
                            ${item.hearing_date ? `সর্বশেষ শুনানীর তারিখ: ${toBnDigits(item.hearing_date)}` : ''}
                            ${item.next_hearing_date ? `<br><br>পরবর্তী শুনানীর তারিখ: ${toBnDigits(item.next_hearing_date)}` : ''}
                        </td>
                         <td class="left-align">
                             ${item.law_officers ? item.law_officers : ""}
                          <br>
                          ${item.officer_names ? item.officer_names : ""} 
                          <br>
                          ${item.officer_mobiles ? item.officer_mobiles : ""}
                        </td>
                    </tr>
                `).join('')}
            </tbody>
        </table>
    </body>
    </html>
    `;
    };


    const handlePrint = () => {
        const printContent = generatePrintContent();
        const printWindow = window.open('', '_blank');

        if (printWindow) {
            printWindow.document.write(printContent);
            printWindow.document.close();

            // Wait for content to load then print
            printWindow.onload = () => {
                setTimeout(() => {
                    printWindow.print();
                }, 500);
            };
        }
    };

    const styles = {

        datePicker: { width: '100%', height: '36px' },
        textarea: { width: '100%', padding: '8px', border: '1px solid #d1d5db', borderRadius: '4px', fontSize: '14px', resize: 'none' },

    };
    const handleDeleteHearingDate = async (hearingId) => {
        try {
            await deleteHearingDateApi(hearingId);
            alert('শুনানি তারিখ সফলভাবে মুছুন করা হয়েছে');
            const { data: body } = await getHearingDatesByCaseEntryApi(selectedCaseId);
            setHearingDates(Array.isArray(body.data) ? body.data : []);
            setHearingFormData({
                hearing_date: '',
                next_hearing_date: '',
                hearing_notes: ''
            });
        } catch (error) {
            console.error('Error deleting hearing date:', error);
            alert('শুনানি তারিখ মুছুন করতে ব্যর্থ');
        } finally {
            setHearingModalLoading(false);
        }
    };

    return (
        <div className="page-wrapper">
            <Helmet>
                <title>অন্যান্য অধস্তন আদালতের চলমান মামলার তালিকা</title>
                <meta name="description" content="অন্যান্য অধস্তন আদালতের চলমান মামলার তালিকা" />
                <style>{`
                    .modal.show {
                        display: block !important;
                    }
                    .modal-backdrop.show {
                        display: block !important;
                    }
                    .modal {
                        background-color: rgba(0, 0, 0, 0.5);
                    }
                `}</style>
            </Helmet>

            <div className="content">
                <div className="page-header">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="page-title text-center mb-4">

                                <strong>অন্যান্য অধস্তন আদালতের চলমান মামলার তালিকা </strong>
                            </h3>
                        </div>
                    </div>
                </div>

                {/* Action Buttons */}
                <div className="row mb-4 action-buttons">
                    <div className="col-sm-12 text-end">
                         <Button
                            type="danger"
                            style={{ backgroundColor: '#52c41a', borderColor: '#52c41a', color: 'white' }}
                            onClick={handlePrint}
                            icon={<PrinterOutlined style={{ fontSize: 20 }} />}
                            iconPosition="start"
                            className="print-button"
                        >
                            প্রিন্ট
                        </Button>
                    </div>
                </div>

                {/* Filter Section */}
                <div className="filter-section">
                    <div className="row mb-3">
                        <div className="col-md-3 mb-3">
                            <label className="form-label">জেলা</label>
                            <Select
                                {...commonSelectProps}
                                value={filters.district || undefined}
                                onChange={(value) => handleFilterChange('district', value)}
                            >
                                {districts?.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">আদালতের নাম</label>
                            <Select
                                {...commonSelectProps}
                                value={filters.courtType || undefined}
                                onChange={(value) => handleFilterChange('courtType', value)}
                            >
                                {courtTypes?.map((option) => (
                                    <Option key={option.value} value={option.value}>
                                        {option.label}
                                    </Option>
                                ))}
                            </Select>
                        </div>

                        <div className="col-md-3 mb-3">
                            <label className="form-label">মামলা নং</label>
                            <Input
                                placeholder="মামলা নং"
                                value={filters.caseNo}
                                onChange={(e) => handleFilterChange('caseNo', e.target.value)}
                                style={{ height: 36 }}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">পরবর্তী শুনানীর তারিখ</label>
                            <RangePicker
                                value={dateRange}
                                onChange={(values) => setDateRange(values)}
                                format={dateFormat}
                                allowClear
                                style={{ width: '100%' }}
                            />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label className="form-label">মামলা দায়েরের তারিখ</label>
                            <RangePicker
                                value={dateRange1}
                                onChange={(values) => setDateRange1(values)}
                                format={dateFormat}
                                allowClear
                                style={{ width: '100%' }}
                            />
                        </div>

                        <div className="col-md-3 mb-3 d-flex justify-content-start align-items-end">
                            <Button
                                type="primary"
                                icon={<SearchOutlined />}
                                onClick={handleSearch}
                                loading={loading}
                                className="search-button"
                                style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
                            >
                                অনুসন্ধান করুন
                            </Button>
                        </div>
                    </div>




                </div>

                {/* Data Table */}
                <div className="row">
                    <div className="col-md-12">
                        <div className="table-container">
                            <div className="table-responsive">
                                <Table
                                    columns={columns}
                                    dataSource={data}
                                    pagination={{
                                        total: data?.length,
                                        showTotal: (total, range) =>
                                            `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                                        // showSizeChanger: true,
                                        // onShowSizeChange: onShowSizeChange,
                                        itemRender: itemRender,
                                        pageSize: 10000,
                                        // showQuickJumper: true
                                    }}
                                    loading={loading}
                                    bordered
                                    size="large"
                                    rowClassName={(record, index) =>
                                        index % 2 === 0 ? 'table-row-light' : 'table-row-dark'
                                    }
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Final Result Modal - Bootstrap */}
            {console.log("Modal state:", isModalVisible, "Final result data:", finalResultData)}

            {/* Bootstrap Modal */}
            <div className={`modal fade ${isModalVisible ? 'show' : ''}`}
                id="finalResultModal"
                tabIndex="-1"
                style={{ display: isModalVisible ? 'block' : 'none', zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setIsModalVisible(false);
                    }
                }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">চূড়ান্ত রায় বিস্তারিত</h5>
                            <button type="button"
                                className="btn-close"
                                onClick={() => setIsModalVisible(false)}
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {modalLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">লোড হচ্ছে...</span>
                                    </div>
                                    <div className="mt-2">লোড হচ্ছে...</div>
                                </div>
                            ) : finalResultData ? (
                                <div>
                                    <div className="card mb-3">
                                        <div className="card-header">
                                            <h6 className="mb-0">মামলার তথ্য</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6 mb-2">
                                                    <strong>মামলা নং:</strong> {toBnDigits(finalResultData.case_number) || 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>জেলা:</strong> {finalResultData.district_name || 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>আদালত:</strong> {finalResultData.court_type_name || 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>মামলার তারিখ:</strong> {toBnDigits(finalResultData.filing_date) || 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card mb-3">
                                        <div className="card-header bg-success text-white">
                                            <h6 className="mb-0">রায়ের তথ্য</h6>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-6 mb-2">
                                                    <strong>রায় ঘোষণার তারিখ:</strong> {toBnDigits(finalResultData.judgment_date) || 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>ফলাফল:</strong>
                                                    {finalResultData.outcome_code === 'GOVT_FOR' ? ' সরকারের পক্ষে' :
                                                        finalResultData.outcome_code === 'GOVT_AGAINST' ? ' সরকারের বিপক্ষে' : 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>নকল আবেদনের তারিখ:</strong> {finalResultData.copy_applied_date ? toBnDigits(finalResultData.copy_applied_date) : 'N/A'}
                                                </div>
                                                <div className="col-md-6 mb-2">
                                                    <strong>নকল প্রাপ্তির তারিখ:</strong> {finalResultData.copy_received_date ? toBnDigits(finalResultData.copy_received_date) : 'N/A'}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {finalResultData.summary_text && (
                                        <div className="card mb-3">
                                            <div className="card-header bg-warning">
                                                <h6 className="mb-0">রায়ের সংক্ষিপ্ত বিবরণ</h6>
                                            </div>
                                            <div className="card-body">
                                                <p className="mb-0">{finalResultData.summary_text}</p>
                                            </div>
                                        </div>
                                    )}

                                    {finalResultData.documents && finalResultData.documents.length > 0 && (
                                        <div className="card">
                                            <div className="card-header bg-info text-white">
                                                <h6 className="mb-0">সংযুক্ত ডকুমেন্ট</h6>
                                            </div>
                                            <div className="card-body">
                                                <div className="list-group">
                                                    {finalResultData.documents.map((doc, index) => (
                                                        <div key={index} className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span>{doc.name || `ডকুমেন্ট ${index + 1}`}</span>
                                                            {doc.url && (
                                                                <a
                                                                    href={doc.url}
                                                                    target="_blank"
                                                                    rel="noopener noreferrer"
                                                                    className="btn btn-sm btn-outline-primary"
                                                                >
                                                                    দেখুন
                                                                </a>
                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="text-center py-5">
                                    <div className="alert alert-info">কোনো তথ্য পাওয়া যায়নি</div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                className="btn btn-secondary"
                                onClick={() => setIsModalVisible(false)}>
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Backdrop */}
            {isModalVisible && (
                <div className="modal-backdrop fade show" style={{ zIndex: 9998 }}></div>
            )}

            {/* Hearing Date Modal - Bootstrap */}
            <div className={`modal fade ${isHearingModalVisible ? 'show' : ''}`}
                id="hearingDateModal"
                tabIndex="-1"
                style={{ display: isHearingModalVisible ? 'block' : 'none', zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        handleHearingModalClose();
                    }
                }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">শুনানি তারিখ যোগ করুন</h5>
                            <button type="button"
                                className="btn-close"
                                onClick={handleHearingModalClose}
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {hearingModalLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">লোড হচ্ছে...</span>
                                    </div>
                                    <p className="mt-2">লোড হচ্ছে...</p>
                                </div>
                            ) : (
                                <>
                                    {/* Form Section */}
                                    <div className="mb-4">
                                        <h6 className="fw-medium text-dark mb-3 pb-2 border-bottom">
                                            নতুন শুনানি তারিখ যোগ করুন
                                        </h6>
                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label fw-medium">
                                                    সর্বশেষ শুনানির তারিখ <span className="text-danger">*</span>
                                                </label>
                                                <DatePicker
                                                    style={styles.datePicker}
                                                    placeholder="দিন/মাস/বছর"
                                                    value={hearingFormData.hearing_date ? getSafeDateValue(hearingFormData.hearing_date, 'YYYY-MM-DD') : null}
                                                    onChange={(date) => {
                                                        if (date && moment.isMoment(date) && date.isValid()) {
                                                            setHearingFormData({
                                                                ...hearingFormData,
                                                                hearing_date: date.format('YYYY-MM-DD'),
                                                            });
                                                        } else if (date === null) {
                                                            setHearingFormData({
                                                                ...hearingFormData,
                                                                hearing_date: '',
                                                            });
                                                        }
                                                    }}
                                                    format="DD/MM/YYYY"
                                                    locale={locale}
                                                    allowClear={true}
                                                    inputReadOnly={false}
                                                    showToday={true}
                                                    showTime={false}
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    dropdownClassName="date-picker-dropdown"
                                                    onBlur={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (inputValue) {
                                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                                            if (parsedDate.isValid()) {
                                                                setHearingFormData({
                                                                    ...hearingFormData,
                                                                    hearing_date: parsedDate.format('YYYY-MM-DD'),
                                                                });
                                                            }
                                                        }
                                                    }}
                                                />

                                            </div>
                                            <div className="col-md-6">
                                                <label className="form-label fw-medium">
                                                    পরবর্তী শুনানির তারিখ
                                                </label>
                                                <DatePicker
                                                    style={styles.datePicker}
                                                    placeholder="দিন/মাস/বছর"
                                                    value={hearingFormData.next_hearing_date ? getSafeDateValue(hearingFormData.next_hearing_date, 'YYYY-MM-DD') : null}
                                                    onChange={(date) => {
                                                        if (date && moment.isMoment(date) && date.isValid()) {
                                                            setHearingFormData({
                                                                ...hearingFormData,
                                                                next_hearing_date: date.format('YYYY-MM-DD'),
                                                            });
                                                        } else if (date === null) {
                                                            setHearingFormData({
                                                                ...hearingFormData,
                                                                next_hearing_date: '',
                                                            });
                                                        }
                                                    }}
                                                    format="DD/MM/YYYY"
                                                    locale={locale}
                                                    allowClear={true}
                                                    inputReadOnly={false}
                                                    showToday={true}
                                                    showTime={false}
                                                    getPopupContainer={(trigger) => trigger.parentNode}
                                                    dropdownClassName="date-picker-dropdown"
                                                    onBlur={(e) => {
                                                        const inputValue = e.target.value;
                                                        if (inputValue) {
                                                            const parsedDate = moment(inputValue, 'DD/MM/YYYY');
                                                            if (parsedDate.isValid()) {
                                                                setHearingFormData({
                                                                    ...hearingFormData,
                                                                    next_hearing_date: parsedDate.format('YYYY-MM-DD'),
                                                                });
                                                            }
                                                        }
                                                    }}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label className="form-label fw-medium">
                                                    মন্তব্য (সংক্ষিপ্ত)
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={hearingFormData.hearing_notes}
                                                    onChange={(e) => setHearingFormData({
                                                        ...hearingFormData,
                                                        hearing_notes: e.target.value
                                                    })}
                                                    placeholder="শুনানির মন্তব্য লিখুন..."
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                style={{ background: 'rgb(104, 48, 145)', color: 'white', padding: "3px 10px", borderRadius: "5px" }}
                                                onClick={handleHearingFormSubmit}
                                                disabled={hearingModalLoading}
                                            >
                                                {hearingModalLoading ? 'যোগ করা হচ্ছে...' : 'যোগ করুন'}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Existing Hearing Dates Table */}
                                    <div className="mt-4">
                                        <h6 className=" text-dark mb-3 pb-2 border-bottom">
                                            বিদ্যমান শুনানি তারিখসমূহ
                                        </h6>
                                        {hearingDates.length > 0 ? (
                                            <div className="table">
                                                <table className="table table-bordered table-sm" style={{ tableLayout: 'fixed' }}>
                                                    <thead className="" style={{ background: 'rgb(104, 48, 145)', color: 'white' }}>
                                                        <tr>
                                                            <th scope="col" className="fw-medium " style={{ fontSize: '0.75rem', width: '15%' }}>
                                                                ক্রম
                                                            </th>
                                                            <th scope="col" className="fw-medium " style={{ fontSize: '0.75rem', width: '25%' }}>
                                                                সর্বশেষ শুনানির তারিখ
                                                            </th>
                                                            {/* <th scope="col" className="fw-medium text-secondary" style={{ fontSize: '0.75rem' }}>
                                                                পরবর্তী শুনানির তারিখ
                                                            </th> */}
                                                            <th scope="col" className="fw-medium " style={{ fontSize: '0.75rem', width: '30%', whiteSpace: 'normal', wordBreak: 'break-word' }}>
                                                                মন্তব্য (সংক্ষিপ্ত)
                                                            </th>
                                                                <th scope="col" className="fw-medium " style={{ fontSize: '0.75rem', width: '10%' }}>অ্যাকশন </th>

                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {hearingDates.map((item, index) => (
                                                            <tr key={index}>
                                                                <td style={{ fontSize: '0.75rem', width: '15%' }}>{toBnDigits(index + 1)}</td>
                                                                <td style={{ fontSize: '0.75rem', width: '25%' }}>{toBnDigits(item.hearing_date)}</td>
                                                                {/* <td style={{ fontSize: '0.75rem' }}>{toBnDigits(item.next_hearing_date)}</td> */}
                                                                <td style={{ fontSize: '0.75rem', width: '30%', whiteSpace: 'normal', wordBreak: 'break-word' }}>{item.hearing_notes}</td>
                                                                <td style={{ fontSize: '0.75rem', width: '10%' }}> <button type="button" className="btn btn-sm btn-danger" onClick={() => handleDeleteHearingDate(item.hearing_id)}>মুছুন</button></td>


                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-muted">
                                                <p>কোনো শুনানি তারিখ পাওয়া যায়নি</p>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button"

                                style={{ background: "black", color: "white", padding: "3px 10px", borderRadius: "5px" }}
                                onClick={handleHearingModalClose}>
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Hearing Modal Backdrop */}
            {isHearingModalVisible && (
                <div className="modal-backdrop fade show" style={{ zIndex: 9998 }}></div>
            )}
            {/* Comment Modal - Bootstrap */}
            <div className={`modal fade ${isCommentModalVisible ? 'show' : ''}`}
                id="commentModal"
                tabIndex="-1"
                style={{ display: isCommentModalVisible ? 'block' : 'none', zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        handleCommentModalClose();
                    }
                }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">মন্তব্য যোগ করুন/সম্পাদনা করুন</h5>
                            <button type="button"
                                className="btn-close"
                                onClick={handleCommentModalClose}
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {commentModalLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">লোড হচ্ছে...</span>
                                    </div>
                                    <p className="mt-2">লোড হচ্ছে...</p>
                                </div>
                            ) : (
                                <div className="mb-4">
                                    <div className="mb-3">

                                        <div className="row g-3">
                                            <div className="col-12">
                                                <label className="form-label fw-medium">
                                                    মন্তব্য <span className="text-danger">*</span>
                                                </label>
                                                <textarea
                                                    className="form-control"
                                                    rows="6"
                                                    value={commentText}
                                                    onChange={(e) => setCommentText(e.target.value)}
                                                    placeholder="মামলার বিষয়ে আপনার মন্তব্য লিখুন..."
                                                    style={{ minHeight: '120px' }}
                                                />
                                            </div>
                                        </div>
                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                style={{ background: "rgb(104, 48, 145)", color: "white", padding: "5px 20px", borderRadius: "5px", marginRight: "7px" }}
                                                onClick={handleCommentSubmit}
                                                disabled={commentModalLoading}
                                            >
                                                {commentModalLoading ? 'আপডেট করা হচ্ছে...' : 'আপডেট করুন'}
                                            </button>
                                            <button
                                                type="button"
                                                style={{ background: "black", color: "white", padding: "5px 20px", borderRadius: "5px" }}
                                                onClick={handleCommentModalClose}
                                                disabled={commentModalLoading}
                                            >
                                                বাতিল
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                style={{ background: "black", color: "white", padding: "5px 20px", borderRadius: "5px" }}
                                onClick={handleCommentModalClose}>
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Comment Modal Backdrop */}
            {isCommentModalVisible && (
                <div className="modal-backdrop fade show" style={{ zIndex: 9998 }}></div>
            )}
            {/* Responsible Officers Modal - Bootstrap */}
            <div className={`modal fade ${isOfficerModalVisible ? 'show' : ''}`}
                id="responsibleOfficerModal"
                tabIndex="-1"
                style={{ display: isOfficerModalVisible ? 'block' : 'none', zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        setIsOfficerModalVisible(false);
                    }
                }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">দায়িত্বপ্রাপ্ত কর্মকর্তা</h5>
                            <button type="button"
                                className="btn-close"
                                onClick={() => setIsOfficerModalVisible(false)}
                                aria-label="Close"></button>
                        </div>
                        <div className="modal-body">
                            {officerModalLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">লোড হচ্ছে...</span>
                                    </div>
                                    <p className="mt-2">লোড হচ্ছে...</p>
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                        <table className="table table-bordered table-sm">
                                            <thead style={{ background: 'rgb(104, 48, 145)', color: 'white' }}>
                                                <tr>
                                                    <th style={{ width: '40%' }}>কর্মকর্তার নাম</th>
                                                    <th style={{ width: '30%' }}>পদবি </th>
                                                    <th style={{ width: '20%' }}>নম্বর</th>
                                                    <th style={{ width: '10%' }}>অ্যাকশন</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {officers.map((row, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.name}
                                                                onChange={(e) => updateOfficerField(index, 'name', e.target.value)}
                                                                placeholder="কর্মকর্তার নাম"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.profession}
                                                                onChange={(e) => updateOfficerField(index, 'profession', e.target.value)}
                                                                placeholder="পদবি "
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control form-control-sm"
                                                                value={row.phone}
                                                                onChange={(e) => updateOfficerField(index, 'phone', e.target.value)}
                                                                placeholder="মোবাইল নম্বর"
                                                            />
                                                        </td>
                                                        <td className="text-center">
                                                            <button type="button" className="btn btn-sm btn-danger" onClick={() => removeOfficerRow(index)}>মুছুন</button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="d-flex justify-content-between">
                                        <button type="button" style={{ background: "black", color: "white", padding: "5px 20px", borderRadius: "5px" }} onClick={addOfficerRow}>আরও যোগ করুন</button>
                                        <button type="button" style={{ background: "rgb(104, 48, 145)", color: "white", padding: "5px 20px", borderRadius: "5px", marginRight: "7px" }} onClick={handleSaveResponsibleOfficers} disabled={officerModalLoading}>সংরক্ষণ করুন</button>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="modal-footer">
                            <button type="button"
                                style={{ background: "black", color: "white", padding: "5px 20px", borderRadius: "5px" }}
                                onClick={() => setIsOfficerModalVisible(false)}>
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {isOfficerModalVisible && (
                <div className="modal-backdrop fade show" style={{ zIndex: 9998 }}></div>
            )}
            <div className={`modal fade ${isDocumentModalVisible ? 'show' : ''}`}
                id="documentEntryModal"
                tabIndex="-1"
                style={{ display: isDocumentModalVisible ? 'block' : 'none', zIndex: 9999 }}
                onClick={(e) => {
                    if (e.target === e.currentTarget) {
                        handleDocumentModalClose();
                    }
                }}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">ডকুমেন্ট যোগ করুন</h5>
                            <button type="button"
                                className="btn-close"
                                onClick={handleDocumentModalClose}
                                aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            {documentModalLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">লোড হচ্ছে...</span>
                                    </div>
                                    <p className="mt-2">লোড হচ্ছে...</p>
                                </div>
                            ) : (
                                <>
                                    {/* Add New Document */}
                                    <div className="mb-4">
                                        <h6 className="text-dark mb-3 pb-2 border-bottom">
                                            নতুন ডকুমেন্ট যোগ করুন
                                        </h6>

                                        <div className="row g-3">
                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    ডকুমেন্ট নাম <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="ডকুমেন্ট নাম লিখুন"
                                                    value={docFormData.document_name}
                                                    onChange={(e) =>
                                                        setDocFormData({
                                                            ...docFormData,
                                                            document_name: e.target.value
                                                        })
                                                    }
                                                />
                                            </div>

                                            <div className="col-md-6">
                                                <label className="form-label">
                                                    ডকুমেন্ট ফাইল <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    onChange={(e) =>
                                                        setDocFormData({
                                                            ...docFormData,
                                                            file: e.target.files[0]
                                                        })
                                                    }
                                                />
                                            </div>
                                        </div>

                                        <div className="mt-3">
                                            <button
                                                type="button"
                                                style={{ background: 'rgb(104, 48, 145)', color: 'white', padding: "3px 10px", borderRadius: "5px" }}
                                                onClick={handleDocumentSubmit}
                                                disabled={documentModalLoading}
                                            >
                                                {documentModalLoading ? 'যোগ করা হচ্ছে...' : 'যোগ করুন'}
                                            </button>
                                        </div>
                                    </div>

                                    {/* Existing Documents Table */}
                                    <div className="mt-4">
                                        <h6 className="text-dark mb-3 pb-2 border-bottom">
                                            বিদ্যমান ডকুমেন্টসমূহ
                                        </h6>

                                        {documents.length > 0 ? (
                                            <div className="table">
                                                <table className="table table-bordered table-sm" style={{ tableLayout: 'fixed' }}>
                                                    <thead style={{ background: 'rgb(104, 48, 145)', color: 'white' }}>
                                                        <tr>
                                                            <th style={{ width: '10%' }}>ক্রম</th>
                                                            <th style={{ width: '30%' }}>ডকুমেন্ট নাম</th>
                                                            <th style={{ width: '40%' }}>ফাইল</th>
                                                            <th style={{ width: '20%' }}>অ্যাকশন</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {documents.map((item, index) => (
                                                            <tr key={index}>
                                                                <td>{index + 1}</td>
                                                                <td>{item.file_name}</td>
                                                                <td>
                                                                    <a href={resolveDocHref(item.file_url)} target="_blank" rel="noopener noreferrer">
                                                                        দেখুন
                                                                    </a>
                                                                </td>
                                                                <td className="text-center">
                                                                    <button
                                                                        className="btn btn-sm btn-danger"
                                                                        onClick={() => handleDeleteDocument(item.file_id)}
                                                                    >
                                                                        ডিলিট
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-muted">
                                                <p>কোনো ডকুমেন্ট পাওয়া যায়নি</p>
                                            </div>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                type="button"
                                style={{ background: "black", color: "white", padding: "3px 10px", borderRadius: "5px" }}
                                onClick={handleDocumentModalClose}
                            >
                                বন্ধ করুন
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RunningCaseReport;